export const {COLUMNS}=[
    {
        accessor:'Text'
    },
    {
        accessor:'Photo1'
    },
    {
        accessor:'Photo2'
    },
    {
        accessor:'Photo3'
    }
]

